import * as objectConstants from '../constants/objectConstants';

export let SPECIIFIC_IMAGE_SIZES = [
    {
        constant: objectConstants.IMAGE_WIDTH_5,
        value: 5
    },
    {
        constant: objectConstants.IMAGE_WIDTH_10,
        value: 10
    },
    {
        constant: objectConstants.IMAGE_WIDTH_15,
        value: 15
    },
    {
        constant: objectConstants.IMAGE_WIDTH_20,
        value: 20
    },
    {
        constant: objectConstants.IMAGE_WIDTH_25,
        value: 25
    },
    {
        constant: objectConstants.IMAGE_WIDTH_30,
        value: 30
    },
    {
        constant: objectConstants.IMAGE_WIDTH_35,
        value: 35
    },
    {
        constant: objectConstants.IMAGE_WIDTH_40,
        value: 40
    },
];


export let ASSET_IMAGE_SIZES = [
    {
        constant: objectConstants.ASSET_IMAGE_WIDTH_10,
        value: 10
    },
    {
        constant: objectConstants.ASSET_IMAGE_WIDTH_15,
        value: 15
    },
    {
        constant: objectConstants.ASSET_IMAGE_WIDTH_20,
        value: 20
    },
    {
        constant: objectConstants.ASSET_IMAGE_WIDTH_25,
        value: 25
    },
    {
        constant: objectConstants.ASSET_IMAGE_WIDTH_30,
        value: 30
    },
    {
        constant: objectConstants.ASSET_IMAGE_WIDTH_35,
        value: 35
    },
    {
        constant: objectConstants.ASSET_IMAGE_WIDTH_40,
        value: 40
    }
];

export let TOP_ASSET_IMAGE_SIZES = [
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_10,
        value: 10
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_20,
        value: 20
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_30,
        value: 30
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_40,
        value: 40
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_50,
        value: 50
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_60,
        value: 60
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_70,
        value: 70
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_80,
        value: 80
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_90,
        value: 90
    },
    {
        constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_100,
        value: 100
    }
];

let HOT_SPOT_LARGE_SCREEN_MAX = {
    constant: objectConstants.HOT_SPOT_TYPE_LARGE_SCREEN,
    maxWidth: objectConstants.HOT_SPOT_LARGE_SCREEN_MAX_WIDTH,
    percentageOfMax: 0,
    maxHeight: 0,
};
let HOT_SPOT_NO_SCREEN_MAX = {
    constant: objectConstants.HOT_SPOT_TYPE_NO_SCREEN,
    maxWidth: objectConstants.HOT_SPOT_NO_SCREEN_MAX_WIDTH,
    percentageOfMax: 0,
    maxHeight: 0,
};
let HOT_SPOT_FULL_SCREEN_MAX = {
    constant: objectConstants.HOT_SPOT_TYPE_FULL_SCREEN,
    maxWidth: objectConstants.HOT_SPOT_FULL_SCREEN_MAX_WIDTH,
    percentageOfMax: 0,
    maxHeight: 0,
};
let HOT_SPOT_MOBILE_SCREEN_MAX = {
    constant: objectConstants.HOT_SPOT_TYPE_MOBILE_SCREEN,
    maxWidth: objectConstants.HOT_SPOT_MOBILE_SCREEN_MAX_WIDTH,
    percentageOfMax: 0,
    maxHeight: 0,
};


export let HOT_SPOT_MAX_SIZES = [
    HOT_SPOT_LARGE_SCREEN_MAX,
    HOT_SPOT_NO_SCREEN_MAX,
    HOT_SPOT_FULL_SCREEN_MAX,
    HOT_SPOT_MOBILE_SCREEN_MAX
];


/** WEBPACK FOOTER **
 ** ./src/models/objectModels.js
 **/